
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import React, { useEffect, useState } from 'react';
import AdminEditNewsForm from '../components/AdminComponents/AdminEditNewsForm';
const AdminEditNews = () => {
 return (
    <>
    <InnerBanner pageKey="adminEditNews" />
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-9'>
                     <AdminEditNewsForm/>
                </div>
                <div className='col-lg-3'>
                    <DashboardSidebar/>
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminEditNews;
